import { getConfig } from '../config/config';
import { getKeycloakInstance } from '../config/keycloak';
import {
  APIKeyPayload,
  CreateAPIKeyResponse,
  SearchAPIKeysResponse,
  UpdateAPIKeyPayload,
} from '../constants/types';
import { getTenant } from '../utils/getKeycloakConfig';
import makeRequest from './makeRequest';

const baseUrl = () =>
  `${getConfig().utilitiesApiEndpoint}/${getTenant()}/api/v1/key/apikeys`;

const authHeaders = () => ({
  Authorization: `Bearer ${getKeycloakInstance()?.token}`,
});

const fetchApiKeysPaged = async (
  query: string,
): Promise<SearchAPIKeysResponse> => {
  const url = `${baseUrl()}?type=synthetic${query}`;

  try {
    const { data } = await makeRequest('GET', url, '', authHeaders());
    return data;
  } catch (error: any) {
    throw error?.response;
  }
};

const createSyntheticApi = async (
  payload: APIKeyPayload,
): Promise<CreateAPIKeyResponse> => {
  const url = `${baseUrl()}/synthetic`;

  try {
    const { data } = await makeRequest('POST', url, payload, authHeaders());
    return data;
  } catch (error: any) {
    throw error?.response;
  }
};

const updateApiKey = async (
  id: string,
  payload: UpdateAPIKeyPayload,
): Promise<void> => {
  const url = `${baseUrl()}/${id}`;

  try {
    await makeRequest('PUT', url, payload, authHeaders());
  } catch (error: any) {
    throw error?.response;
  }
};

const revokeApiKey = async (id: string): Promise<void> => {
  const url = `${baseUrl()}/${id}/revoke`;

  try {
    await makeRequest('PUT', url, '', authHeaders());
  } catch (error: any) {
    throw error?.response;
  }
};

const deleteApiKey = async (id: string): Promise<void> => {
  const url = `${baseUrl()}/${id}`;

  try {
    await makeRequest('DELETE', url, '', authHeaders());
  } catch (error: any) {
    throw error?.response;
  }
};

export {
  fetchApiKeysPaged,
  createSyntheticApi,
  revokeApiKey,
  updateApiKey,
  deleteApiKey,
};
